module.exports = __webpack_public_path__ + "images/lvyue2.jpg?v=f45f0a7f";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/index/lvyue2.jpg
 ** module id = 112
 ** module chunks = 1 2
 **/